import { createApi } from '@reduxjs/toolkit/query/react'
import { BaseRequest } from '../models'
import { OnboardingTrackEvent } from '../../apps/professional-app/fa/common/tracking'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'

// Define a service using a base URL and expected endpoints
const _BASE_URL = import.meta.env.REACT_APP_METRICS_API_BASE_URL

export interface TrackingEvent {
  eventName: string
  eventDetails?: { [key: string]: unknown }
}

export interface UserTrackingEvent {
  eventName: string
}
export interface GettingStartedEventsResponse {
  data: UserTrackingEvent[]
}

export interface EventReportingRequest extends BaseRequest {
  event: TrackingEvent
}

const GETTING_STARTED_EVENT_NAMES = Object.values(OnboardingTrackEvent)
export const metricsApi = createApi({
  reducerPath: 'metricsApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  endpoints: (builder) => ({
    getGettingStartedEventsSummary: builder.query<GettingStartedEventsResponse, BaseRequest>({
      query: ({ accountId }) => {
        return {
          url: `/accounts/${accountId}/event-reporting/summary`,
          params: { event_names: GETTING_STARTED_EVENT_NAMES.join(',') },
        }
      },
    }),
    trackEvent: builder.mutation<void, EventReportingRequest>({
      query: (request) => ({
        url: `/accounts/${request.accountId}/event-reporting`,
        method: 'POST',
        body: {
          eventName: request.event.eventName,
          ...(request.event.eventDetails && { eventDetails: request.event.eventDetails }),
        },
        headers: new Headers({ 'X-App-Info': 'ZocksProfessionalDashboard' }),
      }),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetGettingStartedEventsSummaryQuery, useTrackEventMutation } = metricsApi
